module.exports = __webpack_public_path__ + "media/images/icons/arrow-down-6a781edb9758b034743ad0fcb478ea3a.svg";